import { PhoneFormatter } from "../../utils/phone-formatter";

export type KundKontaktpersonDto = {
    id: number;
    fornamn: string;
    efternamn: string;
    telefon: string;
    mobil: string;
    epost: string;
};

export class KontaktpersonViewModel {
    telefon: string;

    get id() {
        return this.model.id;
    }
    get namn() {
        return `${this.model.fornamn} ${this.model.efternamn}`;
    }

    constructor(readonly model: KundKontaktpersonDto) {
        this.telefon = PhoneFormatter.renderPhonePresentation([
            this.model.mobil,
            this.model.telefon
        ]);
    }
}
